import CustomApplicationState from "@crescentParts/Store/CustomApplicationState";
import { getAHRISystemToolConfigState } from "@crescentParts/Store/Data/AHRISystemToolConfig/AHRISystemToolConfigSelector";
import { getAHRISystemToolPaginationDataByCategoryId } from "@crescentParts/Store/Data/AHRISystemToolPagination/AHRISystemToolPaginationSelector";
import AHRISystemToolPageSizeHandler from "@crescentParts/Store/Data/AHRISystemToolPagination/Handler/AHRISystemToolPageSize";
import AHRISystemPaginationHandler from "@crescentParts/Store/Data/AHRISystemToolPagination/Handler/AHRIToolPagination";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import { ProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsState";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { SelectPresentationProps } from "@insite/mobius/Select";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => {
    const attributes = getAHRISystemToolConfigState(state);
    const defaultPageNumber = state?.cpeState?.AHRISystemToolPagination?.ahriSystemToolPageNumber;
    const defaultPageSize = state?.cpeState?.AHRISystemToolPagination?.ahriSystemToolPageSize;
    

    return {
        ahriPagination: state.cpeState.AHRISystemData.ahriPagination,
        defaultPageNumber,
        ahriData: state?.cpeState?.AHRISystemData.ahriData,
        defaultPageSize
    }
};

const mapDispatchToProps = {
    AHRISystemPaginationHandler,
    AHRISystemToolPageSizeHandler
};

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface AHRISystemToolPaginationStyles {
    pagination?: PaginationPresentationProps;
    perPageSelect?: SelectPresentationProps;
    pageSelect?: SelectPresentationProps;
    pageLinkList?: InjectableCss;
    pageLinkListWrapper?: InjectableCss;
    mobileNavContainer?: InjectableCss;
}

export const paginationStyles: AHRISystemToolPaginationStyles = {};

const styles = paginationStyles;

const AHRISystemToolPagination: FC<Props> = ({
    AHRISystemPaginationHandler,
    ahriPagination,
    AHRISystemToolPageSizeHandler,
    defaultPageNumber,
    ahriData,
    defaultPageSize
}) => {
    const totalItemCount = ahriPagination?.totalItemCount || null;
    const [currentPage, setCurentPage] = useState<number>(defaultPageNumber);
    const [currentPageSize, setCurentPageSize] = useState<number>(defaultPageSize);

    useEffect(() => {
        setCurentPage(defaultPageNumber);
        setCurentPageSize(defaultPageSize);
    }, [defaultPageNumber, ahriPagination, defaultPageSize]);


    const changePage = (newPageIndex: number) => {
        setCurentPage(newPageIndex)
        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: newPageIndex,
        })
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = Number(event.currentTarget.value);
        setCurentPageSize(newPageSize);
        AHRISystemToolPageSizeHandler({
            ahriSystemToolPageSize: newPageSize
        })

        AHRISystemPaginationHandler({
            ahriSystemToolPageNumber: 1,
        })
        setCurentPage(1)
    };
    if (ahriPagination && totalItemCount !== 0) {
        return (
            <Pagination
                {...styles.pagination}
                resultsCount={totalItemCount as number}
                currentPage={currentPage}
                resultsPerPage={currentPageSize}
                resultsPerPageOptions={[]}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
                pageSizeCookie="AHRIToolPage-PageSize"
            />
        );
    }
    return null


};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(AHRISystemToolPagination),
    definition: {
        group: "Basic",
        displayName: "AHRI Tool Pagination",
        fieldDefinitions: [

        ],
    },
};

export default widgetModule;